import { render, staticRenderFns } from "./GroupSideBar.vue?vue&type=template&id=f0586352&scoped=true&"
import script from "./GroupSideBar.vue?vue&type=script&lang=js&"
export * from "./GroupSideBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupSideBar.vue?vue&type=style&index=0&id=f0586352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0586352",
  null
  
)

export default component.exports